import { render, staticRenderFns } from "./datosBono.vue?vue&type=template&id=61e76e8c&scoped=true"
import script from "./datosBono.vue?vue&type=script&lang=js"
export * from "./datosBono.vue?vue&type=script&lang=js"
import style0 from "./datosBono.vue?vue&type=style&index=0&id=61e76e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e76e8c",
  null
  
)

export default component.exports